<template>
  <AppLayout>
    <div class="inventory">
      <section id="suppliers-add">
      <div class="container">
        <h5 class="text-primary fw-bold">View Stock - {{ batch?.batchNo }}
          <button class="btn btn-success btn-sm" style="margin-right: 15px; background-color: #d1e7dd !important; color: black; border: none">Completed</button>
          <button class="btn btn-success btn-sm" style="background-color: #d1e7dd !important; color: black; border: none" v-if="batch?.isVerified == true">Verified</button>
          <button class="btn btn-danger btn-sm" v-else>Unverified</button>
          <button class="btn btn-primary btn-sm" v-if="batch?.isSplit == true" style="margin-left: 15px;">Partial</button>
          <button class="btn btn-primary btn-sm" v-if="mergedBatch != 'none'" 
          style="margin-left: 15px;" @click="this.$router.push('/transaction/pdfbatch/'+mergedBatch?.id)">Merged to {{ mergedBatch?.batchNo }}</button>
          
          <button v-if="batch?.Purchase" class="btn-default btn btn-sm pull-right" style="margin-top: 0px;float:right; border: 1px solid #000;margin-right: 15px;"  @click="this.$router.push('/purchases/pdf/'+batch?.Purchase?.id)">View PO</button>
          <button v-if="batch?.Purchase?.status === 'partial' || batch?.Purchase?.status === 'partially' || batch?.Purchase?.status === 'partially_fulfilled'" class="btn-warning btn btn-sm pull-right" style="margin-top: 0px;float:right; border: 1px solid #000;margin-right: 15px;" @click="openDiscrepancies">View Discrepancies</button>
          <button v-if="batch?.isSplit != true && batch?.isMerge == false" class="btn-default btn btn-sm pull-right" style="margin-top: 0px;float:right; border: 1px solid #000;margin-right: 10px; " @click="showModal">Merge Receipt</button>
          <a class="btn-default btn btn-sm pull-right" target="_blank" :href="`${urlServer}/files/${batch?.document}`" v-if="batch?.document" style="margin-top: 0px;float:right; border: 1px solid #000;margin-right: 10px; font-weight: 400 !important; padding: 2px 5px !important;">View Ref Doc</a>
          <button v-if="batchId" class="btn-default btn btn-sm pull-right" style="margin-top: 0px;float:right; border: 1px solid #000;margin-right: 15px;"  @click="this.$router.push('/transaction/pdfbatch/'+batch?.id)">BPN Summary</button>
        </h5>
        <div class="row mt-3">
          <h6 class="col-md-2 fw-bold">1. Delivery Details</h6>
          <h6 class="col-md-10 fw-bold">2. Courier & Supplier Details</h6>
        </div>
        <div>
          <div class="form">
            <SkeletonLoader v-if="isBatchLoading" type="form" :count="4" />
            <template v-else>            
              <div class="row">
                  <div class="col-md-2">
                      <div class="check-button">
                      <div class="form-group">
                          <label>Internal Delivery?</label>
                          <div class="components-button">
                            <span class="switcher switcher-1">
                                <input type="checkbox" id="switcher-1" v-model="isInternal">
                                <label for="switcher-1"></label>
                            </span>
                          </div>
                      </div>
                      </div>
                  </div>
                <div class="col-md-2" :style="{ 'display': DriverDisplay }">
                  <div class="form-group">
                    <label for="driver">Driver </label>
                    <input type="text" :value="driverObj?.name" id="address" readonly class="form-control">
                  </div>
                </div>
                <div class="col-md-2" :style="{ 'display': SupplierDisplay }">
                  <div class="form-group">
                    <label for="suppliers">Supplier</label>
                    <input type="text" :value="batch?.Supplier?.name" id="address" readonly class="form-control">
                  </div>
                </div>
                <div class="col-md-2" :style="{ 'display': SupplierDisplay }">
                  <div class="form-group">
                    <label for="address">Driver's Name</label>
                    <input type="text" v-model="driver" id="address" readonly class="form-control">
                  </div>
                </div>
                <div class="col-md-2" :style="{ 'display': SupplierDisplay }">
                  <div class="form-group">
                    <label for="item-code">Contacts</label>
                    <input type="text" class="form-control" id="item-code" readonly v-model="contacts">
                  </div>
                </div>
                <div class="col-md-2" :style="{ 'display': SupplierDisplay }">
                  <div class="form-group">
                    <label for="item-code">Vehicle Reg No.</label>
                    <input type="text" class="form-control" id="item-code" readonly v-model="vehicle">
                  </div>
                </div>
              </div>

            <div class="row">
              <h6 class="col-md-5 fw-bold">3. Stock Description</h6>
              <h6 class="col-md-7 fw-bold">4. Consignment Details & Documents</h6>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Stock Category</label>
                  <input type="text" class="form-control" id="item-code" readonly :value="batch?.Nog?.nog">
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="item-code">BPN Tags</label>
                  <input type="text" class="form-control" id="item-code" readonly :value="batch?.Tag?.tag">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Project / Site</label>
                  <input type="text" class="form-control" id="item-code" readonly :value="batch?.project">
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="item-code">PO No.</label>
                  <input type="text" class="form-control" id="item-code" readonly :value="batch?.Purchase?.purchaseNo">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Documents</label>
                  <div v-if="batch?.attachments && batch.attachments.length > 0" class="btn-group" role="group">
                    <button v-for="(att, idx) in batch.attachments" :key="att.id" 
                       @click="openDocumentViewer(idx)"
                       class="btn btn-sm btn-outline-primary"
                       :title="`${att.documentType} - Click to preview`">
                      {{ att.documentType }}
                    </button>
                  </div>
                  <div v-else class="form-control" style="background-color: #f5f5f5; color: #999;">
                    No documents
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Reference 1 #</label>
                  <input type="text" class="form-control" id="item-code" readonly :value="batch?.reference1">
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Reference 2 #</label>
                  <input type="text" class="form-control" id="item-code" readonly :value="batch?.reference2">
                </div>
              </div>

            </div>
            </template>
          </div>
        </div>

        <div style="margin-top:30px;">
          <h6 class="fw-bold">5. Add Items</h6>
          <SkeletonLoader v-if="isBatchLoading" type="table" :rows="5" :columns="11" />
          <table v-else class="table table-hover">
                <thead>
                  <th>No.</th>
                  <th>Product Description</th>
                  <th>Unit</th>
                  <th>Sub Unit</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th>Amount</th>
                  <th>Condition</th>
                  <th>Location</th>
                  <th>Comments</th>
                  <th>Action</th>
                </thead>
              <tbody v-if="items?.length > 0">
                  <tr v-for="(item, index) in items" v-bind:key="item.id">
                      <td>{{ (index+1) }}</td>
                      <td>{{ item.Product?.name }}</td>
                      <td>{{ item.Product?.unit?.unit }}</td>
                      <td> - </td>
                      <td>{{ formatQty(item?.quantity) }}</td>
                      <td>{{ formatMoney(item?.price) }}</td>
                      <td>{{ formatMoney((Number(item?.price) || 0) * (Number(item?.quantity) || 0)) }}</td>
                      <td>{{ item?.condition }}</td>
                      <td>{{ item?.Warehouse?.name }}</td>
                      <td>{{ item?.comment }}</td>
                      <td>
                          <button class="btn btn-default btn-sm" style="border:1px solid black;" @click="verifyItem(item.id)" v-if="item.isVerified != true">
                            <span v-if="verifyingId === item.id" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span v-else>Verify</span>
                          </button>
                          <button v-else class="btn btn-success btn-sm" style="background-color: #d1e7dd !important; color: black; border: none">Verified</button>
                      </td>
                  </tr>
                  <tfoot v-if="items?.length > 0">
                    <tr>
                      <td colspan="11" style="border-top: none;">
                        <div style="text-align: right; font-weight: 600">Total: {{ formatMoney(totalAmount) }}</div>
                      </td>
                    </tr>
                  </tfoot>
              </tbody>
              <div v-else>
                <label for="" class="text-danger mt-4" style="width: fit-content; display: block;">No items found</label>
              </div>
          </table>

          <div style="margin-bottom: 50px;">
            <button class="btn btn-default" style="float: right; margin-right: 10px;border:1px solid black;" @click="this.$router.push('/transaction')">Close</button>
          </div>
        </div>
      </div>
      </section>
    </div>
  

<Modal v-if="isVisible" @close="closeModal" >
  <template v-slot:header>
    <strong>Merge Receipt</strong>
    <p>Kindly confirm that you want to merge receipt.</p>
  </template>

  <template v-slot:body>
    <div class="row">
      <div class="col-12 mt-1" >
        <label for="item-code">Merge with BPN</label>
        <select v-model="mergeId" class="col-7 form-control" id="batchnos"  v-if="batchnos.length > 0">
            <option v-for="batch in batchnos" v-bind:Key="batch.id" :value="batch.id">
                {{ batch?.batchNo }}
            </option>
        </select>
      </div>
      <div class="form-group col-12">
        <label for="item-code">Merge Comment</label>
        <input type="text" class="form-control" v-model="comment">
      </div>
    </div>
  </template>

  <template v-slot:footer>
  <button class="btn-style small" style="border: 1px solid black; float: right;" @click="mergeBatch">Confirm</button>
  <button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 10px;" @click="closeModal">Cancel</button>
  </template>
</Modal>
<div v-if="showDiscrepancies" class="svc-modal-overlay" @click.self="closeDiscrepancies">
  <div class="svc-modal-box" style="max-width:900px;">
    <div class="svc-modal-header">
      <h6 class="fw-bold mb-0">Discrepancy Report</h6>
      <button class="btn-close-plain" @click="closeDiscrepancies">&times;</button>
    </div>

    <div class="svc-modal-body">
      <SkeletonLoader v-if="isLoadingDiscrepancies" type="text" :count="6" />
      <template v-else>
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="discrepancy-stats">
              <div class="stat-item">
                <span class="stat-label">Total Quantity Discrepancy</span>
                <span class="badge bg-warning">{{ formatNumberSimple(discrepancies.totals.totalQuantityDiscrepancy) }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Total Price Discrepancy</span>
                <span class="badge bg-info">{{ formatCurrency(discrepancies.totals.totalPriceDiscrepancy) }}</span>
              </div>
            </div>
          </div>
        </div>
        <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>No.</th>
                <th>Product</th>
                <th>Original PO Qty</th>
                <th>Remaining Qty</th>
                <th>Batch Qty</th>
                <th>Qty Diff</th>
                <th>Purchase Price</th>
                <th>Batch Price</th>
                <th>Price Diff</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, idx) in discrepancies.items" :key="it.productId">
                <td>{{ idx + 1 }}</td>
                <td>{{ it.productName }}</td>
                <td>{{ formatNumberSimple(it.originalQty) }}</td>
                <td>{{ formatNumberSimple(it.remainingQty) }}</td>
                <td>{{ formatNumberSimple(it.batchQty) }}</td>
                <td>{{ formatNumberSimple(it.qtyDiff) }}</td>
                <td>{{ formatCurrency(it.purchasePrice) }}</td>
                <td>{{ formatCurrency(it.batchPrice) }}</td>
                <td>{{ formatCurrency(it.priceDiff) }}</td>
              </tr>
              <tr v-if="discrepancies.items.length == 0">
                <td colspan="9" class="text-center">No discrepancies found</td>
              </tr>
            </tbody>
          </table>
      </template>
    </div>

    <div class="svc-modal-footer">
      <button class="btn btn-sm btn-style-2" @click="closeDiscrepancies">Close</button>
    </div>
  </div>
</div>
  <div class="fixed-total-bar" v-if="items?.length > 0">
    <div class="fixed-total-content">Total: {{ formatMoney(totalAmount) }}</div>
  </div>

  <DocumentViewer 
    v-if="showDocumentViewer"
    ref="documentViewer"
    :documents="batch?.attachments || []"
    :initial-index="selectedDocumentIndex"
    :url-server="urlServer"
    @close="closeDocumentViewer"
  />
</AppLayout>
</template>

<script>

// replaced SweetAlert with vuetoastify toasts
import AppLayout from '../../../components/AppLayout.vue';
import DocumentViewer from '../../../components/DocumentViewer.vue';
import SkeletonLoader from '../../../components/SkeletonLoader.vue';

export default {
  name: 'ProcessedBatchPage',
  components: {
    AppLayout,
    DocumentViewer,
    SkeletonLoader,
  },
  data: () => ({
    token: JSON.parse(localStorage.getItem('access_token')),
    urlServer:process.env.VUE_APP_URL,
    DriverDisplay: "block",
    SupplierDisplay: "none",
    items: [],
    batchnos:[],
    batchId: "",
    mergeId:"",
    batch: "",
    comment: "",
    isVisible: false,
    isInternal: false,
    stockCategory: "",
    driverId: "",
    driverObj: "",
    mergedBatch:"none",
    driver: "",
    contacts: "",
    vehicle: "",
    showDiscrepancies: false,
    isLoadingDiscrepancies: false,
    discrepancies: { totals: { totalQuantityDiscrepancy: 0, totalPriceDiscrepancy: 0 }, items: [] },
    merging: false,
    verifyingId: null,
    showDocumentViewer: false,
    selectedDocumentIndex: 0,
    isBatchLoading: true,
  }),
  computed: {
    totalAmount() {
      return (this.items || []).reduce((sum, item) => {
        const price = Number(item?.price) || 0
        const qty = Number(item?.quantity) || 0
        return sum + price * qty
      }, 0)
    }
  },
  mounted(){        
      this.batchId = this.$route.params.id
      this.setupBatch(this.batchId)
      this.setupBatchNos()
  },
  methods:{
    showModal() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
    },
    async mergeBatch(){
      const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          body: JSON.stringify({ 
            mergeId: this.mergeId,
            batchId: this.batchId,
            comment: this.comment,
          })
      };
      try{
        this.merging = true;
        const res = await fetch(process.env.VUE_APP_URL+'/batches/merge', requestOptions)
        const data = await res.json()
        if(data.status == true){
          this.isVisible = false;
          if (this.$toast && typeof this.$toast.success === 'function') this.$toast.success('Batch merged');
        }else{
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(data.message || 'Batch merge failed');
        }
      }catch(e){
        console.error(e);
        if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to merge batch');
      }finally{
        this.merging = false;
      }
    },
      async verifyItem (itemId) {
          const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ 
                itemId: itemId,
                batchId: this.batchId,
              })
          };
          try{
            this.verifyingId = itemId;
            const res = await fetch(process.env.VUE_APP_URL+'/batches/verify', requestOptions)
            const data = await res.json()
            if(data.status == true){
              this.items = data.items
            }else{
              if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(data.message || 'Batch item not verified');
            }
          }catch(e){
            console.error(e);
            if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error('Failed to verify item');
          }finally{
            this.verifyingId = null;
          }
      },
      async setupBatch(itemId){
        this.isBatchLoading = true;
        try{
          const requestOptions = {
              method: "GET",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          };
          const res = await fetch(process.env.VUE_APP_URL+'/batches/'+itemId, requestOptions)
          const data = await res.json()
          if(data.status == true){
              this.batch = data.batch;
              //alert(this.batch.documentType)
              this.batchId = data.batch.id;
            this.purchase = data.batch.Purchase || null;
              this.driverObj = data.driver;
              this.mergedBatch = data.mergedBatch;
              this.isInternal = this.formatBoolean(data.batch.isInternal);
              this.items = data.batch.items;
              this.isInternal = data.batch.isInternal;
              this.driverId= data.batch.driverId;
              this.driver= data.batch.supplierDriver;
              this.contacts= data.batch.supplierContact;
              this.vehicle= data.batch.supplierVehicle;
              this.updateIsInternal();
          }else{
            if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(data.message || 'Batch not found. Try again');
          }
        }finally{
          this.isBatchLoading = false;
        }
      },
      openDiscrepancies(){
        this.showDiscrepancies = true;
        this.isLoadingDiscrepancies = true;
        this.fetchDiscrepancies();
      },
      closeDiscrepancies(){
        this.showDiscrepancies = false;
      },
      formatNumberSimple(value){
        if(value === null || value === undefined) return '0';
        try{
          return new Intl.NumberFormat().format(Number(value));
        }catch(e){
          return String(value);
        }
      },
      formatCurrency(value){
        if(value === null || value === undefined) return '0.00';
        try{
          return new Intl.NumberFormat('en-US', { 
            style: 'currency', 
            currency: 'KES', 
            currencyDisplay: 'code' 
          }).format(Number(value));
        }catch(e){
          return String(value);
        }
      },
      async fetchDiscrepancies(){
        const requestOptions = {
          method: "GET",
          headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        try{
          const res = await fetch(process.env.VUE_APP_URL+`/batches/${this.batchId}/discrepancies`, requestOptions)
          const data = await res.json()
          if(data.status == true){
            this.discrepancies = data
          } else {
            if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(data.message || 'Failed to fetch discrepancies')
          }
        }catch(e){
          if (this.$toast && typeof this.$toast.error === 'function') this.$toast.error(e.message || 'Failed to fetch discrepancies')
        }finally{
          this.isLoadingDiscrepancies = false;
        }
      },
      async setupBatchNos(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/batches/batchno/split', requestOptions)
        const data = await res.json()
        if(data.status == true){
            this.batchnos = data.batches;
        }
      },
      formatBoolean(value){
        if(value){
          return true
        } else{
          return false
        }
      },
      updateIsInternal() {
        if(this.isInternal){
          this.DriverDisplay = "block"
          this.SupplierDisplay = "none"
        } else{
          this.DriverDisplay = "none"
          this.SupplierDisplay = "block"
        }
      },
      openDocumentViewer(index) {
        this.selectedDocumentIndex = index
        this.showDocumentViewer = true
        this.$nextTick(() => {
          this.$refs.documentViewer.open(index)
        })
      },
      closeDocumentViewer() {
        this.showDocumentViewer = false
      }
      
  }
}
</script>

<style lang="scss" scoped>

$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;
$text-color: #000000;

  select {
    /* inline SVG */
    background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-size: auto 50%;
    border-radius: 3px;
    height: 40px;
    border: 1px solid #b4c7e7 !important;
    padding: 5px 30px 5px 10px;
    // disable default appearance
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    &::-ms-expand { display: none };
    &.full{
      width: 100%;
    }
    &:focus, &:hover{
      background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
      border: 1px solid $text-color;
      background-position: right 10px center;
      background-repeat: no-repeat;
      background-size: auto 50%;
    }
  }



  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 13px;
                font-weight: 600;
                font-size: 13px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 13px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                    height: 30px !important;
                  }
                }
              }
            }
          }
        }
      }
</style>

<style scoped>
.fixed-total-bar {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1100;
}
.fixed-total-content{
  background: #ffffff;
  border: 1px solid #dcdcdc;
  padding: 10px 13px;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.06);
  font-weight: 700;
}

.svc-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svc-modal-box {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 560px;
  box-shadow: 0 8px 32px rgba(0,0,0,.18);
  display: flex;
  flex-direction: column;
}

.svc-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 18px;
  border-bottom: 1px solid #e9ecef;
}

.btn-close-plain {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d;
  line-height: 1;
}

.svc-modal-body {
  padding: 16px 18px;
  overflow-y: auto;
}

.svc-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 11px 18px;
  border-top: 1px solid #e9ecef;
}

.discrepancy-stats {
  display: flex;
  gap: 20px;
  align-items: center;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stat-label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.badge {
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
}

.btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.btn-group .btn-outline-primary {
  white-space: nowrap;
  font-size: 12px;
  padding: 4px 12px;
  border-color: #007bff;
  color: #007bff;
  transition: all 0.2s ease;
}

.btn-group .btn-outline-primary:hover {
  background-color: #007bff;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.25);
}
</style>